import { render } from "./PageDropDownMenuEditor.vue?vue&type=template&id=6ca36918"
import script from "./PageDropDownMenuEditor.vue?vue&type=script&lang=js"
export * from "./PageDropDownMenuEditor.vue?vue&type=script&lang=js"

import "./PageDropDownMenuEditor.vue?vue&type=style&index=0&id=6ca36918&lang=scss"

import exportComponent from "/app/tmp/ardia/V3/v2026.29.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__